import React, { useEffect, useState,useMemo } from 'react';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Select } from '../../Shared';
import ContinContact from './ContinContact';
import Informed from './Informed';
import Intergrated from './Integrated';
import Reply from './Reply';
import Sustained from './Sustained';
import Tactile from './Tactile';
import { useAppContext } from '../../context/AppContext';
import Sched2025 from '../../Assets/USPS2025.jpg';
import Sched2026 from '../../Assets/USPS2026.jpg';
import Schedule from './Schedule';
import { usePromoContext } from '../../context/PromoContext';
import Promotionslist from './Promotionslist'
import FAQ from './FAQ';
import { Line, Pie } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, ArcElement, Tooltip, Legend } from 'chart.js';
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, ArcElement, Tooltip, Legend);
 
const promotionDetails = {
  0:{
   title:'Seleet'
  },
  1: { 
    title: "Continuous Contact Promotion", 
    description: "Encourages consistent customer engagement through regular mailings.",
    component: ContinContact
  },
  2: { 
    title: "Informed Delivery Add-On", 
    description: "Enhances marketing campaigns with digital previews of mail pieces.",
    component: Informed 
  },
  3: { 
    title: "Integrated Technology Promotion", 
    description: "Promotes use of QR codes and other tech integrations in mail.",
    component: Intergrated 
  },
  4: { 
    title: "Reply Mail IMbA Promotion", 
    description: "Incentivizes use of Intelligent Mail barcode for reply mail.",
    component: Reply 
  },
  5: { 
    title: "Sustainability Add-On", 
    description: "Rewards environmentally friendly mailing practices.",
    component: Sustained 
  },
  6: { 
    title: "Tactile Sensory Interactive Engagement Promotion", 
    description: "Encourages interactive mail pieces with unique textures and elements.",
    component: Tactile 
  },
};

const PromotionDetails = ({ promotionTypeId, formData, setFormData,reset, setReset }) => {
  
  const details = promotionDetails[promotionTypeId] || { 
    title: "Select a promotion", 
    description: "Please choose a promotion type to view details."
  };

  return (
    <div className="mt-4 p-4 bg-gray-100 dark:bg-gray-700 rounded-lg">
      <h3 className="text-base font-semibold text-gray-700 dark:text-gray-200 mb-2">{details.title}</h3>
      <p className="text-sm text-gray-600 dark:text-gray-300">{details.description}</p>
      {details.component && (
        <div className="mt-4">
          {React.createElement(details.component, { formData,setFormData, reset, setReset })}
        </div>
      )}
    </div>
  );
};

const fake = [
  {
    name: "2025 Air Show",
    type: 'Integrated Technology Promotion',
    submitted: '07/31/20258',
    status: 'Approved'
  },
];

const Promotions = () => {
  const [promotions, setPromotions] = useState();
 
  const [volumeLabels, setVolumeLabels] = useState(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']);
  const [volumeValues, setVolumeValues] = useState([120, 150, 130, 170, 160, 180,201]);
   const [reset, setReset] = useState(false);
  const currentDate = new Date(); 
  const currentYear = currentDate.getFullYear(); 

   const { promoData, setPromoData,selectedPromotionType, setSelectedPromotionType} = usePromoContext();

useEffect(() => {
    window.scrollTo(0, 0);
  }, [reset]);


   const getVolumeData = (labels, data) => ({
  labels,
  datasets: [{
    label: 'Mail Volume (Thousands)',
    data,
    borderColor: '#3B82F6',
    backgroundColor: 'rgba(59, 130, 246, 0.2)',
    fill: true,
    tension: 0.4,
  }],
});
  
 const volumeData = useMemo(() => getVolumeData(volumeLabels, volumeValues), [volumeLabels, volumeValues]);

   console.log(promoData)

  useEffect(() => {
    setPromoData({
      ...promoData,
      promotionType: selectedPromotionType,
      promotionName: promotionDetails[selectedPromotionType]?.title,
promotionsAccept:false
    });
  }, [selectedPromotionType]);

  

  console.log(promoData);

  const promotionsTypes = [
    { name: `${new Date().getFullYear()} Continuous Contact Promotion`, id: 1 },
    { name: `${new Date().getFullYear()} Informed Delivery Add-On`, id: 2 },
    { name: `${new Date().getFullYear()} Intergrated Technology Promotion`, id: 3 },
    { name: `${new Date().getFullYear()} Reply Mail IMbA Promotion`, id: 4 },
    { name: `${new Date().getFullYear()} Substainability Add-On`, id: 5 },
    { name: `${new Date().getFullYear()} Tactile Sensory Interactive Engagement Promotion`, id: 6 },
  ];



const pieData = {
  labels: ['Approved', 'In Progress', 'Rejected'],
  datasets: [{
    data: [81, 15, 4],
    backgroundColor: ['#34D399', '#3B82F6', '#EF4444'],
    hoverOffset: 20,
  }],
};

// Chart options for line chart
const lineChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    y: {
      min: 0,
      max: 400,
      title: {
        display: true,
        text: 'Volume (Thousands)',
        color: '#1F2937',
        font: { size: 12 },
      },
      grid: { color: '#E5E7EB' },
    },
    x: {
      title: {
        display: true,
        text: 'Month',
        color: '#1F2937',
        font: { size: 12 },
      },
      grid: { display: false },
    },
  },
  plugins: {
    legend: { labels: { color: '#1F2937', font: { size: 12 } } },
    tooltip: { backgroundColor: '#1F2937', titleColor: '#FFFFFF', bodyColor: '#FFFFFF' },
  },
};

  console.log(promoData)

  return (
    <div className=''>
<div className="flex flex-row w-full gap-4 overflow-hidden px-4 border-b-1 border-b-gray-400 pb-10">
  {/* Line Chart (Wider) */}
  <div className=" flex-1 max-w-[70%] bg-white dark:bg-gray-800 p-4 rounded-lg shadow-md transform sm:scale-75 md:scale-100 origin-top-left">
    <h2 className="text-base font-semibold text-gray-700 dark:text-gray-200 mb-3">Mail Volume Trends</h2>
    <div className="h-36">
      <Line data={volumeData} options={lineChartOptions} />
    </div>
  </div>
  {/* Pie Chart (Narrower) */}
  <div className="flex-1 max-w-[30%] bg-white dark:bg-gray-800 p-4 rounded-lg shadow-md transform sm:scale-75 md:scale-100 origin-top-left">
    <h2 className="text-base font-semibold text-gray-700 dark:text-gray-200 mb-3">Job Status Distribution</h2>
    <div className="h-30">
      <Pie data={pieData} options={{ responsive: true, maintainAspectRatio: false }} />
    </div>
  </div>
</div>

      <Tabs>
        <TabList>
          <Tab>My Promotions/Incentives</Tab>
          <Tab>Submit New Promotions/Incentives</Tab>
          <Tab>USPS Promotions Calendar</Tab>
          <Tab>FAQ</Tab>
        </TabList>
        <TabPanel className=''>
          <Promotionslist reset={reset} setReset={setReset} />
          {/* <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow-md mb-4">
            <h2 className="text-base font-semibold text-gray-700 dark:text-gray-200 mb-3">My Promotions</h2>
            <div className="overflow-x-auto">
              <table className="w-full text-left text-sm text-gray-700 dark:text-gray-200">
                <thead>
                  <tr className="border-b dark:border-gray-700">
                    <th className="py-1.5 px-3">Campaign Name</th>
                    <th className="py-1.5 px-3">Promotion Type</th>
                    <th className="py-1.5 px-3">Submitted</th>
                    <th className="py-1.5 px-3">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {fake?.map((job) => (
                    <tr key={job.id} className="border-b dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700">
                      <td className="py-1.5 px-3">{job.name}</td>
                      <td className="py-1.5 px-3">{job.type}</td>
                      <td className="py-1.5 px-3">{job.submitted}</td>
                      <td className="py-1.5 px-3">{job.status}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="h-full bg-white  p-4 rounded-lg shadow-md mt-10 text-lg font-bold border-gray-300 border-1">
            {currentYear} USPS Promotion
                <div className="w-full flex text-center">
                  <img src={Sched2026} alt="2025 Schedule" className=" max-w-[90%] h-auto object-contain ml-[5%]" />
                </div>
          </div> */}
        </TabPanel>
        <TabPanel>
          <div className='pb-10'>
          
            <div className='pb-5 font-16 font-bold'>Promotions/Incentives Form</div>
            <div className='font-12'>
              
              Promotion/Incentive Type<span className={selectedPromotionType> '' ? 'text-black' : 'text-red-500'}>*  </span>
            </div>
            <div>
              <Select 
                value={selectedPromotionType}
                onChange={(e) => setSelectedPromotionType(e.target.value)}
              >
                <option value="">Select a promotion type</option>
                {promotionsTypes.map(item => (
                  <option key={item.id} value={item.id}>{item.name}</option>
                ))}
              </Select>
            </div>
            <PromotionDetails promotionTypeId={selectedPromotionType} promoData={promoData} reset={reset} setReset={setReset} setPromoData={setPromoData} />
          <br />
           
          </div>
        </TabPanel>
        <TabPanel><Schedule /></TabPanel>
        <TabPanel><FAQ /></TabPanel>
      </Tabs>
    </div>
  );
};

export default Promotions;